"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const UserMD = _ref => {
  let {
    title = 'User MD',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.844 26q0 0.469-0.313 0.813-0.344 0.344-0.813 0.344t-0.813-0.344-0.344-0.813 0.344-0.813 0.813-0.344 0.813 0.344q0.313 0.344 0.313 0.813v0zM25.156 27.094q0 2.156-1.313 3.375-1.313 1.25-3.469 1.25h-15.594q-2.188 0-3.469-1.25-1.313-1.219-1.313-3.375 0-1.219 0.094-2.344t0.438-2.469q0.313-1.344 0.844-2.375 0.531-1 1.438-1.813 0.938-0.813 2.156-1.094-0.406 0.938-0.406 2.156v3.625q-1.031 0.344-1.656 1.25-0.625 0.875-0.625 1.969 0 1.438 1 2.438t2.438 1 2.438-1 1-2.438q0-1.094-0.656-1.969-0.625-0.906-1.656-1.25v-3.625q0-1.125 0.469-1.688 2.344 1.875 5.25 1.875t5.281-1.875q0.438 0.563 0.438 1.688v1.125q-1.875 0-3.219 1.344t-1.344 3.219v1.594q-0.563 0.531-0.563 1.281 0 0.719 0.5 1.219t1.188 0.5q0.719 0 1.219-0.5t0.5-1.219q0-0.75-0.563-1.281v-1.594q0-0.906 0.688-1.594 0.656-0.688 1.594-0.688t1.625 0.688q0.656 0.688 0.656 1.594v1.594q-0.563 0.531-0.563 1.281 0 0.719 0.5 1.219t1.219 0.5 1.219-0.5 0.5-1.219q0-0.75-0.594-1.281v-1.594q0-1.188-0.594-2.25-0.625-1.063-1.688-1.688 0-0.188 0.031-0.75v-0.875q-0.031-0.25-0.063-0.719t-0.125-0.844-0.219-0.719q1.219 0.281 2.125 1.094 0.938 0.813 1.469 1.813 0.5 1.031 0.844 2.375 0.313 1.344 0.406 2.469 0.125 1.125 0.125 2.344v0zM19.438 11.156q0 2.813-2.031 4.844-2 2-4.844 2t-4.844-2q-2-2.031-2-4.844 0-2.844 2-4.875 2-2 4.844-2t4.844 2q2.031 2.031 2.031 4.875v0z"
  }));
};
var _default = exports.default = (0, _ikon.default)(UserMD);
UserMD.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "UserMD",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'User MD'",
        "computed": false
      },
      "required": false
    }
  }
};